import React from 'react';
import { PropTypes } from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';

import { DynamicContainer } from '../../Layout/DynamicContainer';

import clutchGrey from '../../../../../static/images/about-us/clutch_grey.svg';

import StepNavigation from '../StepNavigation';
import TestimonialSlide from './TestimonialSlide';
import TestimonialLastSlide from './TestimonialLastSlide';
import NextSlideButton from '../NextSlideButton';
import Text, { TextTypes } from '../../../ui/Text';

const TestimonialContent = ({
    styles,
    rules,
    type,
    slides,
    activeIndex,
    moveToNextSlide,
    moveToNextSlideMobile,
    width,
    showClutch,
    handleHover,
    moveToSlideId,
    showSectionTitle,
}) => {
    const handleMobileNextSlide = React.useCallback(
        e => {
            e.stopPropagation();
            moveToNextSlideMobile();
        },
        [moveToNextSlideMobile],
    );

    const { formatMessage } = useIntl();
    const imageAlt = formatMessage({ id: 'aboutUsPage.testimonials.poweredBy.alt' });

    const handleMouseHover = value => {
        handleHover && handleHover(value);
    };

    return (
        <>
            {slides.length > 1 && (
                <DynamicContainer extend={rules.extendStepNavContainer}>
                    <DynamicContainer extend={rules.extendStepNavFluidContainer} isFluid>
                        {/* eslint-disable-next-line */}
                        <div
                            onMouseEnter={() => handleMouseHover(false)}
                            onMouseLeave={() => handleMouseHover(true)}
                            onClick={e => e.stopPropagation()}
                            className={styles.hoverContainer}
                        >
                            {showSectionTitle && (
                                <Text extend={rules.extendText} type={TextTypes.SECTION}>
                                    <h2 className={styles.text}>
                                        <FormattedMessage id="aboutUsPage.testimonials.title" />
                                    </h2>
                                </Text>
                            )}
                            <StepNavigation
                                type={type}
                                slides={slides}
                                currentSlide={activeIndex}
                                nextSlide={moveToNextSlide}
                                handleHover={handleHover}
                                moveToSlideId={moveToSlideId}
                            />
                            {showClutch && (
                                <div className={styles.poweredByContainer}>
                                    <FormattedMessage id="aboutUsPage.testimonials.poweredBy" />
                                    <img src={clutchGrey} alt={imageAlt} className={styles.image} />
                                </div>
                            )}
                        </div>
                    </DynamicContainer>
                </DynamicContainer>
            )}
            <div className={styles.container}>
                {slides.map((slide, index) => {
                    if (index === slides.length - 1 && showClutch) {
                        return <TestimonialLastSlide key={slide.id} />;
                    }
                    return (
                        <TestimonialSlide
                            showClutch={showClutch}
                            width={width}
                            src={slide.src}
                            alt={slide.alt}
                            name={slide.name}
                            company={slide.company}
                            testimonial={slide.testimonial}
                            key={slide.id}
                            logo={slide.logo}
                            link={slide.link}
                            isSingle={slides.length === 1}
                        />
                    );
                })}
            </div>
            {slides.length > 1 && <NextSlideButton extend={rules.extendButton} onClick={handleMobileNextSlide} />}
        </>
    );
};

TestimonialContent.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
        poweredByContainer: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
    }).isRequired,
    rules: PropTypes.shape().isRequired,
    type: PropTypes.string.isRequired,
    slides: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    activeIndex: PropTypes.number.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    moveToNextSlideMobile: PropTypes.func.isRequired,
    width: PropTypes.number.isRequired,
    showClutch: PropTypes.bool,
    moveToSlideId: PropTypes.func.isRequired,
    handleHover: PropTypes.func,
    showSectionTitle: PropTypes.bool,
};

export default TestimonialContent;
